module.exports = __webpack_public_path__ + "themes/fq/img/wheel1.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/wheel1.png
// module id = 68
// module chunks = d-game